// extracted by mini-css-extract-plugin
module.exports = {"audienceChannels":"AudienceChannels_audienceChannels__C4jf3","channelItem":"AudienceChannels_channelItem__uMndE"};